<template>
  <v-card class="orange lighten-5" elevation="3">
    <v-card-title class="white--text orange">Oppsummering</v-card-title>

    <v-simple-table class="orange lighten-5">
      <thead>
        <tr>
          <th>Produkt</th>
          <th>Antall</th>
          <th>Sum</th>
        </tr>
      </thead>

      <tbody>
        <OrderSummaryItem
          v-for="orderline in order.orderlines"
          :key="orderline.id"
          :orderline="orderline"
        />

        <tr v-if="order.orderlines.length == 0">
          <td colspan="3">Ingen varer lagt til.</td>
        </tr>

        <tr v-if="showDeliveryMethod()">
          <td class="text-right" colspan="2">{{ deliveryMethodName }}</td>
          <td>kr {{ deliveryMethodPrice }},-</td>
        </tr>

        <tr v-if="showVat">
          <td class="text-right" colspan="2">Moms</td>
          <td>kr {{ totalVat }},-</td>
        </tr>

        <tr v-if="order.orderlines.length > 0">
          <td colspan="2" class="text-right font-weight-bold">Total</td>
          <td class="font-weight-bold">kr {{ total }},-</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import OrderSummaryItem from "@/components/OrderSummaryItem";

export default {
  name: "OrderSummary",

  components: {
    OrderSummaryItem,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    vendor: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    vatClasses: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },

  computed: {
    showVat() {
      // Only show VAT if we have at least one orderline
      if (this.order.orderlines.length == 0) {
        return false;
      }

      // If the order is loaded from API it will have vat_enabled property
      if (this.order.vat_enabled !== "undefined" && this.order.vat_enabled) {
        return true;
      }

      // No vat_enabled property, lets check our prop instead
      if (typeof this.vendor !== "undefined" && this.vendor.vat_enabled) {
        return true;
      }

      return false;
    },
    totalVat() {
      // If the order is loaded from API it will have vat_total property
      if (typeof this.order.vat_total !== "undefined") {
        return this.order.vat_total;
      }

      // It seems we are in checkout, we need to do the math ourselves
      const vat_classes = this.vatClasses;

      // Get the combined VAT for all orderlines on the order
      const vat_total = this.order.orderlines.reduce((total, orderline) => {
        // Find relevant VAT class for orderline
        const vat_class = vat_classes.find(
          (e) => e.id == orderline.product.vat_class
        );

        // Full price incl. VAT on the orderline
        const orderline_total = orderline.product.price * orderline.quantity;

        // The actual VAT value based on full value
        const orderline_vat_total =
          (orderline_total / (100 + vat_class.percentage)) *
          vat_class.percentage;

        return total + orderline_vat_total;
      }, 0);

      return (vat_total + this.deliveryMethodVat).toFixed(2).replace(".", ",");
    },

    deliveryMethodVat() {
      // We might not actually have a chosen method yet
      if (this.order.delivery_method == null) {
        return 0;
      }

      // If delivery is free there is no VAT
      if (this.order.delivery_method.price == 0) {
        return 0;
      }

      const vat_class = this.vatClasses.find(
        (e) => e.id == this.order.delivery_method.vat_class
      );

      // No calculation needed for the zero-VAT class
      if (vat_class.percentage == 0) {
        return 0;
      }

      return (
        (this.order.delivery_method.price / (100 + vat_class.percentage)) *
        vat_class.percentage
      );
    },

    deliveryMethodName() {
      if (typeof this.order.delivery_method == "object") {
        return this.order.delivery_method.name;
      } else {
        return this.order.delivery_method_name;
      }
    },

    deliveryMethodPrice() {
      if (typeof this.order.delivery_method == "object") {
        return parseFloat(this.order.delivery_method.price);
      } else {
        return parseFloat(this.order.delivery_method_price);
      }
    },

    total() {
      const orderline_total = this.order.orderlines.reduce(
        (total, orderline) => {
          return total + orderline.product.price * orderline.quantity;
        },
        0
      );

      if (this.order.delivery_method !== null) {
        return orderline_total + this.deliveryMethodPrice;
      }

      return orderline_total;
    },
  },

  methods: {
    showDeliveryMethod() {
      if (this.order.orderlines.length == 0) {
        return false;
      }

      if (this.order.delivery_method !== null) {
        return true;
      }

      return false;
    },
  },
};
</script>
